import { Outlet, createFileRoute, useNavigate } from '@tanstack/solid-router';
import { createEffect } from 'solid-js';

import { COUNTRY_CODE } from '~/lib/graphql/types';
import { setCountryCode } from '~/lib/i18n';

const LOCALE_TO_COUNTRY: Record<string, COUNTRY_CODE> = {
    'en-SG': COUNTRY_CODE.SG,
    'en-MY': COUNTRY_CODE.MY
};

export const Route = createFileRoute('/$locale')({
    component: LocaleLayout
});

function LocaleLayout() {
    const params = Route.useParams();
    const navigate = useNavigate();

    createEffect(() => {
        const loc = params().locale;
        const country = LOCALE_TO_COUNTRY[loc];
        if (country) {
            setCountryCode(country);
        } else {
            navigate({
                to: '/$locale',
                params: { locale: 'en-SG' },
                search: (prev) => prev,
                replace: true
            });
        }
    });

    return <Outlet />;
}
